const getIdInArrayOfObject = (array: { id: number | string; title: string }[]) => {
    return array.map(
        (value) => value.id
      );
}

export default getIdInArrayOfObject;